import React from 'react';
import TaxbillListContainer from '../../containers/taxIssuedmng/TaxbillListContainer';

const TaxIssuedListPage = () => {
  return <TaxbillListContainer />
};

export default TaxIssuedListPage;
